import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AutenticarComponent} from './page/autenticar/autenticar.component';
import {AvaliacaoAuditorComponent} from './page/avaliacao-auditor/avaliacao-auditor.component';
import {AvaliacaoComponent} from './page/avaliacao/avaliacao.component';
import {CadastroComponent} from './page/cadastro/cadastro.component';
import {ClassificacaoComponent} from './page/classificacao/classificacao.component';
import {ComofuncionaComponent} from './page/comofunciona/comofunciona.component';
import {EmpresasAuditarComponent} from './page/empresas-auditar/empresas-auditar.component';
import {EmpresasSegurasComponent} from './page/empresas-seguras/empresas-seguras.component';
import {EmpresasComponent} from './page/empresas/empresas.component';
import {EmpresascertificadasComponent} from './page/empresascertificadas/empresascertificadas.component';
import {EntrarComponent} from './page/entrar/entrar.component';
import {InicioComponent} from './page/inicio/inicio.component';
import {MapsComponent} from './page/maps/maps.component';
import {MateriaisComponent} from './page/materiais/materiais.component';
import {PoliticaprivacidadeComponent} from './page/politicaprivacidade/politicaprivacidade.component';
import {RecuperarsenhaComponent} from './page/recuperarsenha/recuperarsenha.component';
import {TemosUsoComponent} from './page/temos-uso/temos-uso.component';
import {ResultadoautoavaliacaoComponent} from './page/resultadoautoavaliacao/resultadoautoavaliacao.component';
import {AdesaoComponent} from './page/adesao/adesao.component';


const routes: Routes = [
  {path: '', redirectTo: '/inicio', pathMatch: 'full'},
  {path: 'inicio', component: AutenticarComponent},
  {path: 'criar-conta', component: CadastroComponent},
  {path: 'entrar', component: EntrarComponent},
  {path: 'temos-de-uso', component: TemosUsoComponent},
  {path: 'politica-de-privacidade', component: PoliticaprivacidadeComponent},
  {path: 'lista-unidades', component: EmpresascertificadasComponent},
  {path: 'empresas', component: EmpresasComponent},
  {path: 'avaliacao/:id', component: AvaliacaoComponent},
  {path: 'classificacao/:id', component: ClassificacaoComponent},
  {path: 'como-funciona', component: ComofuncionaComponent},
  {path: 'recuperarsenha/:id', component: RecuperarsenhaComponent},
  {path: 'autenticar', component: AutenticarComponent},
  {path: 'material-e-treinamento', component: MateriaisComponent},
  {path: 'empresas-auditar', component: EmpresasAuditarComponent},
  {path: 'avaliacao-auditor/:id', component: AvaliacaoAuditorComponent},
  {path: 'maps/:uf', component: MapsComponent},
  {path: 'resultadoautoavaliacao/:id', component: ResultadoautoavaliacaoComponent},
  {path: 'adesao', component: AdesaoComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
